module.exports = __webpack_public_path__ + "media/product/ctg-2-41632e05.png";